import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.54511 16.7241C9.33566 16.7241 9.16046 16.6536 9.01948 16.5125C8.87837 16.3715 8.80782 16.1963 8.80782 15.9868V11.1633L4.14282 5.23704C3.98254 5.02329 3.95927 4.80107 4.07302 4.57037C4.18691 4.33954 4.379 4.22412 4.64927 4.22412H15.4664C15.7366 4.22412 15.9287 4.33954 16.0426 4.57037C16.1564 4.80107 16.1331 5.02329 15.9728 5.23704L11.3078 11.1633V15.9868C11.3078 16.1963 11.2373 16.3715 11.0962 16.5125C10.9552 16.6536 10.78 16.7241 10.5705 16.7241H9.54511ZM10.0578 10.7241L14.1828 5.47412H5.93282L10.0578 10.7241Z",
		fill: "currentColor"
	})
});
export default SvgFilter;
